import React from 'react';
import { useLang } from '../../../_LangContext';
import { mergeClasses } from '@griffel/react';

const UIIconBtnWLabel = ({ className, iconClass, labelTexts, onClick }) =>
{
	const { lang } = useLang();

	className = mergeClasses('icon-btn circle-w-label', className);

	return (
		<button className={className} onClick={onClick}>
			<div className="btn-main">
				<p className={`icon ${iconClass}`} />
			</div>
			<div className="btn-label">
				{labelTexts[lang]}
			</div>
		</button>
	);
};

export default UIIconBtnWLabel;